import {Injectable, inject} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {ToasterService} from "./toaster.service";
import {ProfileService} from './profile.service';
import {TokenService} from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private toasterService: ToasterService = inject(ToasterService);
  private profileService: ProfileService = inject(ProfileService);
  private tokenService: TokenService = inject(TokenService);


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public setError(title: string, message: any, toast: boolean, logout: boolean): void {
    if (logout) {
      this.tokenService.clearToken();
      this.profileService.resetProfile();
    }

    if (message instanceof HttpErrorResponse) {
      if (message.status === 555 && toast) {
        this.toasterService.error(title, message.message);
        return;
      }
      console.log('%c ErrorService: %c' + title + ' - ' + message.message, 'background: #333333; color: #ff7777; padding: 5px 5px 5px 0px;', 'background: #333333; color: #00cc55; padding: 5px 5px 5px 0px;');
      return;
    }

    if (message instanceof Error) {
      console.log('%c ErrorService: %c' + title + ' - ' + JSON.stringify(message), 'background: #333333; color: #ff7777; padding: 5px 5px 5px 0px;', 'background: #333333; color: #00cc55; padding: 5px 5px 5px 0px;');
      return;
    }

    if (typeof message === 'string') {
      console.log('%c ErrorService: %c' + title + ' - ' + message, 'background: #333333; color: #ff7777; padding: 5px 5px 5px 0px;', 'background: #333333; color: #00cc55; padding: 5px 5px 5px 0px;');
      return;
    }

    console.warn(title);
    console.warn(message);
  }
}
